export default __webpack_public_path__ + "static/media/our-meeting-image.3f9d08ca.png";